import { Component, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { Toast } from 'primeng/toast'

import { NavigationHistoryProvider } from '@ti/core/common/services'

import { MaintenanceModel } from '../../../monitoring/models/maintenance.model'
import { TIAdminMenuComponent } from './menu/menu.component'

@Component({
  selector: 'app-ti-admin-layout',
  templateUrl: 'layout.component.html',
  styleUrls: ['layout.component.scss'],
  // Shared by the Monitoring menu badge and the Maintenance page so both see the same Firestore
  // listener/state instead of each starting their own.
  providers: [MaintenanceModel],
  imports: [RouterOutlet, Toast, TIAdminMenuComponent],
})
export class TiAdminLayoutComponent {
  protected readonly navigationHistoryProvider = inject(NavigationHistoryProvider)
}
